import { useState } from 'react'

import Icon from '../../Icon'

import Button from '../Button'

import { SyntheticButtonContainer } from './styles'

import { SyntheticButtonProps } from './types'

export default function SyntheticButton({
  variant = 'primary',
  heightClass = 'regular',
  options,
  dropdownLabel,
  pulseAnimate,
  disabled = false
}: SyntheticButtonProps) {
  const [primaryOption, ...extraOptions] = options

  const [expanded, setExpanded] = useState(false)

  const toggleExpanded = () =>
    setExpanded((previousExpanded) => !previousExpanded)

  const collapse = () => setExpanded(false)

  const makeOptionClick =
    ({ onClick }: (typeof options)[0], isExtraOption?: boolean) =>
    () => {
      if (onClick) {
        onClick()
      }

      if (isExtraOption) {
        ;(document.activeElement as HTMLButtonElement).blur()
      }

      collapse()
    }

  return (
    <SyntheticButtonContainer
      heightClass={heightClass}
      pulseAnimate={pulseAnimate}
      textColor={primaryOption.textColor ?? 'white'}
      impactClass={primaryOption.impactClass ?? 'navigation'}
    >
      <Button
        heightClass={heightClass}
        variant={variant}
        {...primaryOption}
        onClick={makeOptionClick(primaryOption)}
        disabled={disabled}
      >
        {primaryOption.children}
      </Button>

      <div>
        <Button
          onClick={toggleExpanded}
          aria-haspopup='true'
          aria-expanded={expanded}
          aria-label={dropdownLabel}
          variant='secondary'
          impactClass={primaryOption.impactClass}
          heightClass={heightClass}
          disabled={disabled}
          style={disabled ? { borderLeft: 0, marginLeft: '-4px' } : {}}
        >
          <Icon iconName='DropdownArrowLow' />
        </Button>

        <ul hidden={!expanded}>
          {extraOptions.map((extraOption, index) => (
            <li key={index}>
              <Button
                heightClass={heightClass}
                variant={variant}
                {...extraOption}
                onClick={makeOptionClick(extraOption, true)}
              />
            </li>
          ))}
        </ul>
      </div>
    </SyntheticButtonContainer>
  )
}
